// api.ts
import axios from "axios";
import i18n from "../i18n";


// const API_BASE_URL = "https://amaarbackapi.pythonanywhere.com/api/v1"; // free host server
// const API_BASE_URL = "https://amaar.m-electro.uz/api/v1"; // test host server2
const API_BASE_URL = "https://api.amaar.uz/api/v1"; // amaar server
const API_V2_BASE_URL = "https://api.amaar.uz/api/v2"; // amaar server (v2 — do'kon bo'yicha guruhlangan savat/checkout)

// Clear stored auth data and force logout/redirect when token is invalid
let isLoggingOut = false;
const handleUnauthorized = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("user");

  // const currentLang = i18n.language || localStorage.getItem("i18nextLng") || "uz";
  // const redirectPath = `/${currentLang}`;

  // if (window.location.pathname !== redirectPath) {
  //   window.location.replace(redirectPath);
  // } else {
  //   window.location.reload();
  // }
};

const createApiClient = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 10000,
  });

  // Har bir requestga til va token qo'shish
  instance.interceptors.request.use((config) => {
    const currentLang = i18n.language || "uz";
    config.headers["Accept-Language"] = currentLang;

    const token = localStorage.getItem("access");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // eslatma: faqat shu ishlatiladi
    }
    return config;
  });

  // 401 bo'lsa tokenni o'chirish va 503 Maintenance holatini tekshirish
  instance.interceptors.response.use(
    (response) => {
      // Version-check yoki boshqa API javoblarida maintenance holatini tekshirish
      if (response.data?.is_maintenance || response.data?.maintenance?.is_enabled) {
        const detail = response.data?.maintenance || response.data;
        window.dispatchEvent(
          new CustomEvent("maintenance-mode", { detail })
        );
      }
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        console.error("Unauthorized request, clearing token");
        handleUnauthorized();
      } else if (
        error.response?.status === 503 &&
        error.response?.data?.code === "MAINTENANCE_MODE"
      ) {
        window.dispatchEvent(
          new CustomEvent("maintenance-mode", { detail: error.response.data })
        );
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

const api = createApiClient(API_BASE_URL);
export const apiV2 = createApiClient(API_V2_BASE_URL);

export default api;
